import {useLayoutEffect} from 'react';
import {useTranslation} from 'react-i18next';

export const normalizeProfileLanguage = (value?: string | null) => {
    const language = value?.trim().toLowerCase().split(/[-_]/)[0];
    return language && ['pl', 'en', 'ru', 'uk'].includes(language) ? language : undefined;
};

export function useProfileLanguage(isAuthenticated: boolean, profileLanguage?: string) {
    const {i18n} = useTranslation();
    const language = isAuthenticated ? normalizeProfileLanguage(profileLanguage) : undefined;
    const currentLanguage = i18n.resolvedLanguage;

    useLayoutEffect(() => {
        if (!language) return;
        // Keep the legacy settings cache and i18next's detector cache in sync.
        localStorage.setItem('language', language);
        localStorage.setItem('i18nextLng', language);
        if (currentLanguage !== language) void i18n.changeLanguage(language);
    }, [language, currentLanguage, i18n]);

    return !language || currentLanguage === language;
}
